<template>
  <tile
    :data-sid="service.id"
    class="tile"
    @click.native="tileClicked"
  >
    <template v-slot:icon>
      <round-icon-button
        v-if="hasError"
        transform="shrink-7 left-0.9 up-0.6"
        icon="exclamation-triangle"
        textColor="text-danger"
        style="position: absolute;"
      />
      <service-icon-wrapper :service="service" style="display: block" />
    </template>

    <template v-slot:action-buttons>
      <template v-if="serviceApp.servicesSelectionEnabled">
        <font-awesome-icon
          :icon="isSelected ? 'check-circle' : ['far', 'circle']"
          size="lg"
          class="m-3"
        />
      </template>
      <template v-else>
        <round-icon-button
          v-if="hasDevices && !serviceTileClickNavigatesToNextLevel"
          class="m-4"
          :class="[{ 'hiding-btn': !$isMobile }]"
          icon="th"
          @click.stop="navigateToDevices"
        />
        <round-icon-button
          v-if="serviceTileClickNavigatesToNextLevel"
          class="m-4"
          :class="[{ 'hiding-btn': !$isMobile }]"
          icon="bars"
          transform="shrink-6 right-0.9"
          @click.stop="showControlPanel"
        />
      </template>
    </template>

    <template v-slot:line1>
      {{ serviceName }}
    </template>

    <template v-slot:line2>
      {{ placeName }}
    </template>

    <template v-slot:line3>
      {{ service.specific_type || getServiceGroupById(service.groupId).name }}
    </template>

    <template v-slot:line4>
      <statuses :service="service" on-tile />
    </template>
  </tile>
</template>

<script>
import ControlPanel from '@/components/services/ControlPanel.vue';
import Statuses from '@/components/services/service/tile/Statuses.vue';
import { mapGetters, mapState, mapActions } from 'vuex';
import ServiceIconMixin from '@/mixins/ServiceIconMixin';
import RoundIconButton from '@/components/utils/RoundIconButton.vue';
import Tile from '@/components/utils/tiles/Tile';
import ServiceIconWrapper from '@/components/services/service/ServiceIconWrapper';

export default {
  name: 'ServiceTile',
  mixins: [
    ServiceIconMixin,
  ],
  props: {
    service: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showButtons: false,
    };
  },
  computed: {
    ...mapGetters('service-group', [
      'getServiceGroupById',
    ]),
    ...mapState('app', {
      serviceApp: 'service',
    }),
    ...mapGetters('user', [
      'getUserData',
    ]),
    ...mapGetters([
      'getServiceName',
      'getPlaceName',
      'hasServiceError',
    ]),
    serviceName() {
      return this.getServiceName(this.service.id);
    },
    placeName() {
      return this.getPlaceName(this.service.places[0]);
    },
    isSelected() {
      return this.serviceApp.servicesSelectionEnabled && this.selected;
    },
    hasDevices() {
      return this.service.childsIds.length > 0
        && this.getUserData.show_devices;
    },
    serviceTileClickNavigatesToNextLevel() {
      return this.$store.state.app.navigationSettings.serviceTileClickNavigatesToNextLevel;
    },
    hasError() {
      return this.hasServiceError(this.service.id);
    },
  },
  methods: {
    ...mapActions([
      'toggleServiceSelection',
    ]),
    tileClicked() {
      if (this.serviceApp.servicesSelectionEnabled) {
        if (this.selected) {
          this.$emit('serviceDeselected', this.service.id);
        } else {
          this.$emit('serviceSelected', this.service.id);
        }
      } else {
        if (this.serviceTileClickNavigatesToNextLevel) {
          this.navigateToDevices();
        } else {
          this.showControlPanel();
        }
      }
    },
    showControlPanel() {
      this.$showPanel({
        component: ControlPanel,
        width: '500px',
        keepAlive: false,
        props: {
          service: this.service,
        },
      });
    },
    navigateToDevices() {
      if (this.hasDevices) {
        this.$router.push({
          name: 'service-devices',
          params: {
            serviceId: this.service.id,
            serviceGroupId: this.service.groupId,
            placeId: this.service.placeId,
          },
        });
      }
    },
  },
  components: {
    ServiceIconWrapper,
    Tile,
    RoundIconButton,
    Statuses,
  },
};
</script>

<style scoped>
</style>
